export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_29-01a3a3c5c856dda6524579e07584b1f6.jpg";